import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";



//查询列表
export  const findList =(params)=>{
    return http.get('/client/findList',params)
}

//新增 POST /client/add
export function add(params){
    return http.postJSON("/client/add",params);
}

//编辑 POST /client/update
export function update(params){
    return http.postJSON("/client/update",params);
}

//导出 GET /client/exportExcel
export function exportExcel(params) {
  return http.getExcel("/client/exportExcel",params)
}

//删除 POST /repe/repe/delete
export function deletes(params){
    return http.postJSON("/client/delete?"+jsonToFormData(params),{});
}


// WEBPACK FOOTER //
// ./src/services/customer.js